export default __webpack_public_path__ + "static/uk-android-elevate-540335881ca0cefe892ae5dd9e363cb3.webp";